import { render, staticRenderFns } from "./GroupMailController.vue?vue&type=template&id=05b1e7e8"
import script from "./GroupMailController.vue?vue&type=script&lang=js"
export * from "./GroupMailController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports